import layout from '@/components/common/layout';
import majorList from '../views/major/list';
import majorCreate from "../views/major/create";

export default [
    {
        path: '/major',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "专业列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'major_list',// 子选项
                    }
                },
                component: majorList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增专业",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'major_list',// 子选项
                    }
                },
                component: majorCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑专业",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'major_list',// 子选项
                    }
                },
                component: majorCreate,
            },
        ]
    },
];
